module.exports = __webpack_public_path__ + "static/web-02d7cbcabf130823dea0c52c4986a9f1.jpg";